import React, { ReactElement } from 'react';

import * as S from './InformationCard.styles';

type Prop = {
  highlightedTitle: string;
  remainingTitle: string;
  description: string;
  imageSrc: string;
}

export const InformationCard = ({ highlightedTitle, remainingTitle, description, imageSrc }: Prop): ReactElement => {
  return (
    <S.Wrapper>
      <S.Content>
        <S.TextContainer>
          <S.Title>
            <S.HighlightedTitle dangerouslySetInnerHTML={{ __html: highlightedTitle }} />
            <S.RemainingTitle dangerouslySetInnerHTML={{ __html: remainingTitle }} />
          </S.Title>
          <S.Description dangerouslySetInnerHTML={{ __html: description }} />
        </S.TextContainer>
        <S.ImageContainer>
          <S.Image
            alt={`${highlightedTitle}-image`}
            src={imageSrc}
          />
        </S.ImageContainer>
      </S.Content>
    </S.Wrapper>
  );
};